import React from "react";
import { useTranslation } from "react-i18next";

const BLOOD_GROUPS = ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"];
const COMPONENTS = ["PRBC", "FFP", "Platelets", "Cryo"];

const InventoryHeatmapChart = ({ data }) => {
  const { t } = useTranslation();

  const getColor = (value) => {
    if (value === 0) return "#dc3545";
    if (value <= 10) return "#fd7e14";
    if (value <= 25) return "#ffc107";
    if (value <= 50) return "#20c997";
    return "#28a745";
  };

  const getTextColor = (value) => {
    if (value === 0) return "#fff";
    if (value <= 10) return "#fff";
    if (value <= 25) return "#000";
    return "#fff";
  };

  const getStatusLabel = (value) => {
    if (value === 0) return t("Out of Stock");
    if (value <= 10) return t("Critical");
    if (value <= 25) return t("Low");
    if (value <= 50) return t("Adequate");
    return t("Good");
  };

  return (
    <div>
      <div style={{ overflowX: "auto" }}>
        <table
          className="table table-bordered mb-0"
          style={{ minWidth: "600px", tableLayout: "fixed" }}
        >
          <thead>
            <tr style={{ backgroundColor: "#f8f9fa" }}>
              <th
                style={{
                  width: "100px",
                  textAlign: "center",
                  fontWeight: "600",
                  padding: "12px 8px",
                  verticalAlign: "middle",
                }}
              >
                {t("Component")}
              </th>
              {BLOOD_GROUPS.map((bg) => (
                <th
                  key={bg}
                  style={{
                    textAlign: "center",
                    fontWeight: "600",
                    padding: "12px 8px",
                  }}
                >
                  {bg}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {COMPONENTS.map((component) => (
              <tr key={component}>
                <td
                  style={{
                    fontWeight: "600",
                    backgroundColor: "#f8f9fa",
                    textAlign: "center",
                    padding: "12px 8px",
                    verticalAlign: "middle",
                  }}
                >
                  {t(component)}
                </td>
                {BLOOD_GROUPS.map((bg) => {
                  const value = data[component]?.[bg] || 0;
                  return (
                    <td
                      key={`${component}-${bg}`}
                      title={`${t(component)} ${bg}: ${value} ${t("units")} - ${getStatusLabel(value)}`}
                      style={{
                        backgroundColor: getColor(value),
                        color: getTextColor(value),
                        textAlign: "center",
                        fontWeight: "600",
                        padding: "12px 8px",
                        fontSize: "14px",
                        cursor: "default",
                        transition: "all 0.2s ease",
                      }}
                    >
                      {value}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div
        className="d-flex justify-content-center align-items-center mt-3"
        style={{ gap: "15px", flexWrap: "wrap" }}
      >
        <div className="d-flex align-items-center" style={{ gap: "6px" }}>
          <div
            style={{
              width: "16px",
              height: "16px",
              backgroundColor: "#dc3545",
              borderRadius: "3px",
            }}
          ></div>
          <span style={{ fontSize: "12px" }}>{t("Out of Stock")} (0)</span>
        </div>
        <div className="d-flex align-items-center" style={{ gap: "6px" }}>
          <div
            style={{
              width: "16px",
              height: "16px",
              backgroundColor: "#fd7e14",
              borderRadius: "3px",
            }}
          ></div>
          <span style={{ fontSize: "12px" }}>{t("Critical")} (1-10)</span>
        </div>
        <div className="d-flex align-items-center" style={{ gap: "6px" }}>
          <div
            style={{
              width: "16px",
              height: "16px",
              backgroundColor: "#ffc107",
              borderRadius: "3px",
            }}
          ></div>
          <span style={{ fontSize: "12px" }}>{t("Low")} (11-25)</span>
        </div>
        <div className="d-flex align-items-center" style={{ gap: "6px" }}>
          <div
            style={{
              width: "16px",
              height: "16px",
              backgroundColor: "#20c997",
              borderRadius: "3px",
            }}
          ></div>
          <span style={{ fontSize: "12px" }}>{t("Adequate")} (26-50)</span>
        </div>
        <div className="d-flex align-items-center" style={{ gap: "6px" }}>
          <div
            style={{
              width: "16px",
              height: "16px",
              backgroundColor: "#28a745",
              borderRadius: "3px",
            }}
          ></div>
          <span style={{ fontSize: "12px" }}>{t("Good")} (50+)</span>
        </div>
      </div>
    </div>
  );
};

export default InventoryHeatmapChart;
